<template>
  <b-modal
    title="NOVO FORMULÁRIO"
    size="lg"
    no-close-on-backdrop
    hide-footer
    id="new_semiology_form"
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <!-- Detalhes -->
      <template v-if="step == 'details'">
        <div class="row">
          <div class="col-xl-12">
            <label-required-field label="Nome" />
            <b-input
              :disabled="loading"
              type="text"
              ref="autofocus"
              v-model="name"
            />
          </div>
          <div class="col-xl-12">
            <label-required-field label="Descrição" />
            <b-textarea :disabled="loading" rows="3" v-model="description" />
          </div>
        </div>
      </template>
      <!-- Visibilidade -->
      <template v-if="step == 'visibility'">
        <!-- Perfis -->
        <div class="p-2 mb-2">
          <b-row>
            <b-col>
              <b-row no-gutters>
                <b-col>
                  <h6 class="upper-text worksansr">
                    VISÍVEL PARA TODOS OS PERFIS?
                  </h6>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col>
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="profile_public_answer"
                  >
                    RESPONDEREM
                  </b-checkbox>
                </b-col>
                <b-col>
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="profile_public_read"
                  >
                    VEREM RESPONDIDOS
                  </b-checkbox>
                </b-col>
                <b-col>
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="profile_public_edit"
                  >
                    EDITAREM O FORMULÁRIO
                  </b-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <v-data-iterator
            v-if="
              !profile_public_answer ||
              !profile_public_read ||
              !profile_public_edit
            "
            :search="profiles_search"
            :items="profiles"
            hide-default-footer
            must-sort
            sort-by="name"
            :sort-desc="false"
            :page.sync="profiles_page"
            :items-per-page="profiles_items_per_page"
            @page-count="profiles_page_count = $event"
          >
            <template #header>
              <b-row no-gutters>
                <b-col>
                  <h6 class="upper-text text-fourteen">Adicionar Perfis:</h6>
                  <b-input
                    v-model="profiles_search"
                    placeholder="Procurar perfis"
                    class="mb-2"
                  />
                </b-col>
              </b-row>
            </template>

            <template #item="{ item }">
              <b-row
                no-gutters
                style="border-bottom: 1px solid #e1e1e1"
                v-show="item.name != 'MASTER'"
              >
                <b-col> {{ item.name }} </b-col>
                <b-col v-if="!profile_public_answer" cols="auto">
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="item.answer"
                  >
                    RESPONDER
                  </b-checkbox>
                </b-col>
                <b-col v-if="!profile_public_read" cols="auto">
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="item.read"
                  >
                    VER RESPONDIDO
                  </b-checkbox>
                </b-col>
                <b-col v-if="!profile_public_edit" cols="auto">
                  <b-checkbox
                    inline
                    :unchecked-value="false"
                    :value="true"
                    v-model="item.edit"
                  >
                    EDITAR
                  </b-checkbox>
                </b-col>
              </b-row>
            </template>

            <template #footer v-if="profiles.length > 5">
              <b-row align-h="end">
                <b-col cols="auto">
                  <v-pagination
                    v-model="profiles_page"
                    :length="profiles_page_count"
                  />
                </b-col>
              </b-row>
            </template>
          </v-data-iterator>
        </div>
        <!-- tipo de visibilidade -->
        <div>
          <b-row>
            <b-col>
              <b-form-group>
                <h6 class="upper-text worksansr">
                  SELECIONAR VISIBILIDADE POR?
                </h6>
                <b-form-radio
                  v-model="visibility_type"
                  v-for="type in visibility_types"
                  :key="type.id"
                  :value="type"
                  inline
                >
                  {{ type.name }}
                </b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <!-- graus de dependência -->
        <div
          v-if="visibility_type.value === 'DEGREE_OF_DEPENDENCE'"
          class="p-2 mb-2"
        >
          <b-row>
            <b-col>
              <v-data-iterator
                :search="degrees_of_dependence_search"
                :items="degrees_of_dependence"
                hide-default-footer
                must-sort
                sort-by="name"
                :sort-desc="false"
                :page.sync="degrees_of_dependence_page"
                :items-per-page="degrees_of_dependence_items_per_page"
                @page-count="degrees_of_dependence_page_count = $event"
              >
                <template #header>
                  <b-row no-gutters>
                    <b-col>
                      <h6 class="upper-text text-fourteen">
                        Adicionar graus de dependência:
                      </h6>
                      <b-input
                        v-model="degrees_of_dependence_search"
                        placeholder="Procurar graus de dependência"
                        class="mb-2"
                      />
                    </b-col>
                  </b-row>
                </template>

                <template #item="{ item }">
                  <b-row no-gutters style="border-bottom: 1px solid #e1e1e1">
                    <b-col>
                      <b-checkbox
                        inline
                        :unchecked-value="false"
                        :value="true"
                        v-model="item.selected"
                        @input="filterIgnoredSelectionResidents"
                      >
                        {{ item.name }}
                      </b-checkbox>
                    </b-col>
                  </b-row>
                </template>

                <template #footer v-if="degrees_of_dependence.length > 5">
                  <b-row align-h="end">
                    <b-col cols="auto">
                      <v-pagination
                        v-model="degrees_of_dependence_page"
                        :length="deegres_of_dependence_page_count"
                      />
                    </b-col>
                  </b-row>
                </template>
              </v-data-iterator>
            </b-col>
          </b-row>
        </div>
        <!-- individual -->
        <div v-if="visibility_type.value === 'MANUAL'" class="p-2 mb-2">
          <b-row>
            <b-col>
              <v-data-iterator
                :search="manual_selection_residents_search"
                :items="manual_selection_residents"
                hide-default-footer
                must-sort
                sort-by="name"
                :sort-desc="false"
                :page.sync="manual_selection_residents_page"
                :items-per-page="manual_selection_residents_items_per_page"
                @page-count="manual_selection_residents_page_count = $event"
              >
                <template #header>
                  <b-row no-gutters>
                    <b-col>
                      <h6 class="upper-text text-fourteen">
                        Adicionar residentes:
                      </h6>
                      <b-input
                        v-model="manual_selection_residents_search"
                        placeholder="Procurar residentes"
                        class="mb-2"
                      />
                    </b-col>
                  </b-row>
                </template>

                <template #item="{ item }">
                  <b-row no-gutters style="border-bottom: 1px solid #e1e1e1">
                    <b-col>
                      <b-checkbox
                        inline
                        :unchecked-value="false"
                        :value="true"
                        v-model="item.selected"
                      >
                        {{ item.name }}
                      </b-checkbox>
                    </b-col>
                  </b-row>
                </template>

                <template #footer v-if="manual_selection_residents.length > 5">
                  <b-row align-h="end">
                    <b-col cols="auto">
                      <v-pagination
                        v-model="manual_selection_residents_page"
                        :length="manual_selection_residents_page_count"
                      />
                    </b-col>
                  </b-row>
                </template>
              </v-data-iterator>
            </b-col>
          </b-row>
        </div>
        <!-- exceto -->
        <div
          v-if="
            visibility_type.value === 'DEGREE_OF_DEPENDENCE' ||
            visibility_type.value === 'PUBLIC'
          "
          class="p-2 mb-2"
        >
          <b-row>
            <b-col>
              <v-data-iterator
                :search="residents_ignored_search"
                :items="residents_ignored"
                hide-default-footer
                must-sort
                sort-by="name"
                :sort-desc="false"
                :page.sync="residents_ignored_page"
                :items-per-page="residents_ignored_items_per_page"
                @page-count="residents_ignored_page_count = $event"
              >
                <template #header>
                  <b-row no-gutters>
                    <b-col>
                      <h6 class="upper-text text-fourteen">
                        Exceto residentes (opcional):
                      </h6>
                      <b-input
                        v-model="residents_ignored_search"
                        placeholder="Procurar residentes"
                        class="mb-2"
                      />
                    </b-col>
                  </b-row>
                </template>

                <template #item="{ item }">
                  <b-row no-gutters style="border-bottom: 1px solid #e1e1e1">
                    <b-col>
                      <b-checkbox
                        inline
                        :unchecked-value="false"
                        :value="true"
                        v-model="item.selected"
                      >
                        {{ item.name }}
                      </b-checkbox>
                    </b-col>
                  </b-row>
                </template>

                <template #footer v-if="residents_ignored.length > 5">
                  <b-row align-h="end">
                    <b-col cols="auto">
                      <v-pagination
                        v-model="residents_ignored_page"
                        :length="residents_ignored_page_count"
                      />
                    </b-col>
                  </b-row>
                </template>
              </v-data-iterator>
            </b-col>
          </b-row>
          <b-row v-if="isAllResidentsIgnored">
            <b-col>
              <warning-message
                message="VOCÊ SELECIONOU OCULTAR PARA TODOS OS RESIDENTES ATUAIS"
              />
            </b-col>
          </b-row>
        </div>
      </template>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 check-text-center"
        >
          <v-btn
            v-show="step == 'details'"
            :disabled="loading"
            :loading="loading"
            class="btn-cancel m-1"
            @click="$bvModal.hide('new_semiology_form')"
          >
            CANCELAR
          </v-btn>
          <v-btn
            v-show="step == 'visibility'"
            :disabled="loading"
            :loading="loading"
            class="btn-return m-1"
            @click="step = 'details'"
          >
            <i class="fas fa-arrow-left mr-2 text-twenty" /> Voltar
          </v-btn>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 check-text-right"
        >
          <v-btn
            v-show="step == 'details'"
            :disabled="loading"
            :loading="loading"
            class="btn-acess m-1"
            @click.stop="nextStep"
          >
            AVANÇAR
            <i class="fas fa-arrow-right ml-2 text-twenty" />
          </v-btn>
          <v-btn
            v-show="step == 'visibility'"
            :disabled="loading"
            :loading="loading"
            class="btn-save m-1"
            @click.stop="evOnSubmit"
          >
            <i class="fas fa-save mr-2 text-twenty" /> SALVAR
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";
import WarningMessage from "../Components/WarningMessage.vue";

export default {
  name: "NewForm",
  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    WarningMessage,
  },

  data() {
    return {
      errors: [],
      loading: false,
      step: "details",

      name: "",
      description: "",

      headers: [
        { text: "NOME", value: "name" },
        { text: "AÇÕES", value: "actions" },
      ],

      profile_public_answer: true,
      profile_public_read: true,
      profile_public_edit: true,
      profiles_search: "",
      profiles_page: 1,
      profiles_page_count: 0,
      profiles_items_per_page: 5,
      profiles: [],

      visibility_types: [],
      /** @type {{id: number, name: string, value: ("DEGREE_OF_DEPENDENCE"|"MANUAL"|"PUBLIC")}} */
      visibility_type: {},

      degrees_of_dependence_search: "",
      degrees_of_dependence_page: 1,
      degrees_of_dependence_page_count: 0,
      degrees_of_dependence_items_per_page: 5,
      degrees_of_dependence: [],

      /** @type {{
       *   date_of_birth: string,
       *   gender_name: string,
       *   degree_of_dependence_id: number,
       *   id: number,
       *   name: string,
       *   photo_url: string,
       * }[]} */
      residents: [],

      residents_ignored: [],
      residents_ignored_search: "",
      residents_ignored_page: 1,
      residents_ignored_page_count: 0,
      residents_ignored_items_per_page: 5,

      manual_selection_residents: [],
      manual_selection_residents_search: "",
      manual_selection_residents_page: 1,
      manual_selection_residents_page_count: 0,
      manual_selection_residents_items_per_page: 5,
    };
  },

  computed: {
    isAllResidentsIgnored: function () {
      if (this.residents_ignored.length === 0) return false;
      return (
        this.residents_ignored.filter((r) => r.selected).length ===
        this.residents_ignored.length
      );
    },
  },

  watch: {
    residents() {
      this.filterManualSelectionResidents();
      this.filterIgnoredSelectionResidents();
    },

    visibility_type() {
      for (const item of this.degrees_of_dependence) item.selected = false;
      this.filterManualSelectionResidents();
      this.filterIgnoredSelectionResidents();
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.step = "details";
      this.name = "";
      this.description = "";

      this.profile_public_answer = true;
      this.profile_public_read = true;
      this.profile_public_edit = true;
      this.profiles_search = "";
      this.profiles_page = 1;

      this.residents_ignored_search = "";
      this.residents_ignored_page = 1;
      this.residents_ignored_items_per_page = 5;

      this.manual_selection_residents_search = "";
      this.manual_selection_residents_page = 1;
      this.manual_selection_residents_items_per_page = 5;

      this.loading = true;
    },

    async evOnShown() {
      if (this.errors.length == 0) await this.getVisibilityTypes();
      if (this.errors.length == 0) await this.getDegreesOfDependence();
      if (this.errors.length == 0) await this.getProfiles();
      if (this.errors.length == 0) await this.getResidents();
      this.$refs.autofocus.focus();
    },

    async nextStep() {
      this.loading = true;
      this.errors = [];

      if (!this.name) this.errors.push("Informe o nome");
      else if (this.name.length < 3)
        this.errors.push("O nome deve conter pelo menos 3 caracteres");
      else if (this.name.length > 255)
        this.errors.push("O nome deve conter até 255 caracteres");

      if (!this.description) this.errors.push("Informe a descrição");
      else if (this.description.length < 3)
        this.errors.push("A descrição deve conter pelo menos 3 caracteres");
      else if (this.description.length > 4000)
        this.errors.push("A descrição deve conter até 4000 caracteres");

      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      this.step = "visibility";

      this.loading = false;
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        //#region perfil
        if (
          !this.profile_public_answer &&
          !this.profiles.some((profile) => profile.answer)
        )
          this.errors.push("Selecione ao menos um perfil para responder");

        if (
          !this.profile_public_read &&
          !this.profiles.some((profile) => profile.read)
        )
          this.errors.push("Selecione ao menos um perfil para ver respondidos");

        if (
          !this.profile_public_edit &&
          !this.profiles.some((profile) => profile.edit)
        )
          this.errors.push("Selecione ao menos um perfil para editar");
        //#endregion

        //#region grau de dependencia
        if (
          this.visibility_type.value === "DEGREE_OF_DEPENDENCE" &&
          this.degrees_of_dependence.filter((item) => item.selected).length == 0
        )
          this.errors.push("Selecione ao menos um grau de dependência");
        //#endregion

        //#region individual
        if (
          this.visibility_type.value === "MANUAL" &&
          this.manual_selection_residents.filter((item) => item.selected)
            .length == 0
        )
          this.errors.push("Selecione ao menos um residente");

        //#region público
        //#endregion

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        const profiles = {
          answer: this.profile_public_answer
            ? []
            : this.profiles
                .filter((profile) => profile.answer)
                .map((profile) => profile.id),
          read: this.profile_public_read
            ? []
            : this.profiles
                .filter((profile) => profile.read)
                .map((profile) => profile.id),
          edit: this.profile_public_edit
            ? []
            : this.profiles
                .filter((profile) => profile.edit)
                .map((profile) => profile.id),
        };

        const degree_of_dependence_ids = this.degrees_of_dependence
          .filter((item) => item.selected)
          .map((item) => item.id);

        const residents_ignored_ids = this.residents_ignored
          .filter((item) => item.selected)
          .map((item) => item.id);

        const resident_ids = this.manual_selection_residents
          .filter((item) => item.selected)
          .map((item) => item.id);

        const data = {
          name: this.name,
          description: this.description,
          status: this.status_value,
          profiles,
          visibility_type_id: this.visibility_type.id,
          degree_of_dependence_ids:
            this.visibility_type.value === "DEGREE_OF_DEPENDENCE"
              ? degree_of_dependence_ids
              : undefined,
          residents_ignored_ids:
            this.visibility_type.value == "DEGREE_OF_DEPENDENCE" ||
            this.visibility_type.value == "PUBLIC"
              ? residents_ignored_ids
              : undefined,
          resident_ids:
            this.visibility_type.value === "MANUAL" ? resident_ids : undefined,
        };
        const response = await api.post("/rest-home/semiology/form", data);
        const { error, errors, id, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_semiology_form");
          toast(message, "success");
          this.$router.push({ name: "semiology-form", params: { id } });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getVisibilityTypes() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/semiology/form/visibility-type"
        );
        const { error, errors, visibility_types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.visibility_types = visibility_types;
          this.visibility_type = visibility_types[0];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getProfiles() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/profiles");
        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.profiles = profiles.map((profile) => ({
            ...profile,
            answer: false,
            read: false,
            edit: false,
          }));
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getDegreesOfDependence() {
      try {
        this.loading = true;

        const response = await api.get("/default/degrees-of-dependence");
        const { error, errors, degrees_of_dependence } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.degrees_of_dependence = degrees_of_dependence.map((item) => ({
            ...item,
            selected: false,
          }));
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async filterManualSelectionResidents() {
      if (this.visibility_type.value === "MANUAL") {
        this.manual_selection_residents = this.residents.map((item) => ({
          id: item.id,
          name: item.name,
          selected: false,
        }));
      } else this.manual_selection_residents = [];

      this.manual_selection_residents_page_count = Math.ceil(
        this.manual_selection_residents.length /
          this.manual_selection_residents_items_per_page
      );
    },

    async filterIgnoredSelectionResidents() {
      const residents = this.residents.map((item) => ({
        id: item.id,
        name: item.name,
        degree_of_dependence_id: item.degree_of_dependence_id,
        selected: false,
      }));

      if (this.visibility_type.value === "DEGREE_OF_DEPENDENCE") {
        const selected = this.degrees_of_dependence
          .filter((item) => item.selected)
          .map((item) => item.id);

        this.residents_ignored = residents.filter((resident) =>
          selected.includes(resident.degree_of_dependence_id)
        );
      } else if (this.visibility_type.value === "PUBLIC") {
        this.residents_ignored = residents;
      } else this.residents_ignored = [];

      this.residents_ignored_page_count = Math.ceil(
        this.residents_ignored.length / this.residents_ignored_items_per_page
      );
    },
  },
};
</script>

<style></style>
